import React from 'react'
import Gallerypage from '../components/Gallery'
import Footer from '../components/footer'
const Gallery = () => {
  return (
    <>
      <Gallerypage />
      <Footer />
    </>
  )
}

export default Gallery
